import { DatePipe, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Table } from 'primeng/table';
import { debounceTime } from 'rxjs';
import { CardRequestService } from '../card-request.service';
import { CardRequestsFilterService } from '../card-requests-filter.service';

@Component({
    selector: 'app-card-requests-active-filters',
    templateUrl: './card-requests-active-filters.component.html',
    standalone: true,
    imports: [NgFor, NgSwitch, NgIf, NgSwitchCase, DatePipe, TranslateModule]
})
export class CardRequestsActiveFiltersComponent {

    formKeys: string[];
    formControls: Record<string, AbstractControl<any, any>>;
    queryId = '';
    personId = '';
    firstName = '';
    email = '';
    phoneNumber = '';
	@Input() table: Table;

	constructor(
		public readonly cardRequestsFilterService: CardRequestsFilterService,
		public readonly cardRequestService: CardRequestService
	) {
	    this.initializeFormControls();

	    this.cardRequestsFilterService.filterHandler()
	        .pipe(debounceTime(300))
	        .subscribe(() => {
	            this.cardRequestsFilterService.searchingByColumnFilter = true;
	            this.initializeFormControls();
	        });
	}

	initializeFormControls(): void {
	    this.formControls = this.cardRequestsFilterService.form.controls;
	    this.formKeys = [];

	    for (const key in this.formControls) {
	        if (Object.prototype.hasOwnProperty.call(this.formControls, key)) {
	            this.formKeys.push(key);
	        }
	    }

	    this.queryId = this.cardRequestsFilterService.form.controls['queryId'].value;
	    this.personId = this.cardRequestsFilterService.form.controls['personId'].value;
	    this.firstName = this.cardRequestsFilterService.form.controls['firstName'].value;
	    this.email = this.cardRequestsFilterService.form.controls['email'].value;
	    this.phoneNumber = this.cardRequestsFilterService.form.controls['phoneNumber'].value;
	}

	getFormControlObject(key: string): AbstractControl<any, any> {
	    return this.formControls[key];
	}

	isFilterActive(key: string): boolean {
	    const value = this.formControls[key].value;
	    return value != null && value !== '';
	}

	thereIsMoreThanOneFilterActive(): boolean {
	    return this.formKeys.filter(key => this.isFilterActive(key)).length >= 2;
	}

	clearFilter(key: string): void {
	    if (this[`${key}`]) this[`${key}`] = ''; // this.queryId = ''; this.personId = ''; this.firstName = ''; this.email = ''; this.phoneNumber = '';
	    this.cardRequestsFilterService.clearFilter(key);
	}

	clearAllFiltersAndGlobalSearch(): void {
	    this.queryId = '';
	    this.personId = '';
	    this.firstName = '';
	    this.email = '';
	    this.phoneNumber = '';
	    this.cardRequestsFilterService.clearAllFiltersAndGlobalSearch();

	    // reset sort field of the table
	    this.cardRequestsFilterService.resetSortField();
	    if (this.table) { this.table.reset(); }
	}
}
